<div class="card border h-100 bg-light rounded-4 border-0">
  <div class="card-body d-flex flex-column">
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
      <h5 class="mb-0 fw-semibold fs-24 d-flex align-items-center">
        <i class="bi bi-cash-stack me-2 lh-sm"></i>
        Incentives
      </h5>
      @if (!hasIncentive() && canWriteDeals()) {
        <button
          class="btn btn-primary btn-h42 align-items-center"
          appBtnLoader="deal-save-incentive"
          (click)="openIncentiveModal()"
        >
          <i class="bi bi-cash-stack lh-1"></i>
          Add Incentive
        </button>
      }
    </div>

    <div class="card border bg-white border-0 rounded-4 flex-fill overflow-hidden">
      <div class="card-body">
        @if (!hasIncentive()) {
          <div class="text-center py-5 d-flex flex-column justify-content-center h-100">
            <i class="bi bi-cash-stack fs-1 text-muted"></i>

            <p class="text-muted mb-0">
              No incentive found.
              @if (canWriteDeals()) {
                Click <span class="fw-500">Add Incentive</span> to create one.
              }
            </p>
          </div>
        } @else {
          <div class="row g-3">
            <!-- Incentive Details Card -->
            <div class="col-12">
              <div class="card border-0 rounded-4">
                <div class="card-body p-0">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h3 class="mb-0 fw-semibold d-flex align-items-center">
                      <i class="bi bi-coin me-2 lh-sm"></i>
                      Incentive Details
                    </h3>
                    @if (canWriteDeals()) {
                      <div class="d-flex gap-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-secondary btn-h42"
                          (click)="openIncentiveModal()"
                        >
                          <i class="bi bi-pencil-square me-1"></i>
                          Edit
                        </button>
                        <button type="button" class="btn btn-sm btn-danger btn-h42" (click)="deleteIncentive()">
                          <i class="bi bi-trash me-1"></i>
                          Delete
                        </button>
                      </div>
                    }
                  </div>

                  <div class="bg-light p-3 rounded-4">
                    <div class="row gy-3 mb-3">
                      <div class="col-lg-6 col-xl-3">
                        <div class="rounded-3 p-3 bg-white rounded-3 shadow-sm h-100">
                          <label class="text-muted mb-1">
                            <i class="bi bi-geo-alt fs-14 me-1"></i>
                            Lot Price</label
                          >
                          <div class="fw-500 fs-20">{{ incentive()!.lotPrice | currencyFormat }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-xl-3">
                        <div class="rounded-3 p-3 bg-white rounded-3 shadow-sm h-100">
                          <label class="text-muted mb-1">
                            <i class="bi bi-gem fs-14 me-1"></i>
                            Lot Premium</label
                          >
                          <div class="fw-500 fs-20">{{ incentive()!.lotPremium | currencyFormat }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-xl-3">
                        <div class="rounded-3 p-3 bg-white rounded-3 shadow-sm h-100">
                          <label class="text-muted mb-1">
                            <i class="bi bi-house fs-14 me-1"></i>
                            Base Model</label
                          >
                          <div class="fw-500 fs-20">{{ incentive()!.baseModel | currencyFormat }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-xl-3">
                        <div class="rounded-3 p-3 shadow-sm bg-white h-100">
                          <label class="text-muted mb-1">
                            <i class="bi bi-box-seam fs-14 me-1"></i>
                            Addendum Products</label
                          >
                          <div class="fw-500 fs-20">{{ incentive()!.addendumProducts | currencyFormat }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end align-items-center gap-2">
                      <span class="fw-500 fs-18">Total Incentive</span>
                      <span class="fw-500 fs-24 text-primary">{{ incentive()!.total | currencyFormat }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Add/Edit Incentive Modal -->
<ng-template #incentiveModal let-modal>
  <form
    class="needs-validation h-100"
    [formGroup]="incentiveForm"
    (ngSubmit)="submitIncentiveForm()"
    #incentiveFormRef="ngForm"
    autocomplete="off"
  >
    <div class="d-flex flex-column h-100">
      <div class="modal-header">
        <h1 class="modal-title">{{ isEditMode() ? 'Edit' : 'Add' }} Incentive</h1>
        <span (click)="modal.dismiss('Cross click')" role="button">
          <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
        </span>
      </div>

      <div class="modal-body">
        <!-- Form-level validation error -->
        @if (incentiveForm.hasError('atLeastOneRequired') && incentiveFormRef?.submitted) {
          <div class="alert alert-danger mb-3" role="alert">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            Please enter a value in at least one field
          </div>
        }

        <div class="gy-3 row">
          <!-- Lot Price -->
          <div class="col-md-6">
            <label class="form-label">Lot Price</label>
            <currency-input-field
              [disabled]="true"
              formControlName="lotPrice"
              [placeholder]="'Enter Lot Price'"
              [requiredLabel]="false"
            ></currency-input-field>
            @if (incentiveForm.get('lotPrice')?.hasError('min') && incentiveFormRef?.submitted) {
              <div class="text-danger small mt-1">Lot Price must be a positive value</div>
            }
          </div>

          <!-- Lot Premium -->
          <div class="col-md-6">
            <label class="form-label">Lot Premium</label>
            <currency-input-field
              [disabled]="true"
              formControlName="lotPremium"
              [placeholder]="'Enter Lot Premium'"
              [requiredLabel]="false"
            ></currency-input-field>
            @if (incentiveForm.get('lotPremium')?.hasError('min') && incentiveFormRef?.submitted) {
              <div class="text-danger small mt-1">Lot Premium must be a positive value</div>
            }
          </div>

          <!-- Base Model -->
          <div class="col-md-6">
            <label class="form-label">Base Model</label>
            <currency-input-field
              [disabled]="true"
              formControlName="baseModel"
              [placeholder]="'Enter Base Model'"
              [requiredLabel]="false"
            ></currency-input-field>
            @if (incentiveForm.get('baseModel')?.hasError('min') && incentiveFormRef?.submitted) {
              <div class="text-danger small mt-1">Base Model must be a positive value</div>
            }
          </div>

          <!-- Addendum Products -->
          <div class="col-md-6">
            <label class="form-label">Option Incentives</label>
            <currency-input-field
              [disabled]="!canWriteDeals()"
              formControlName="addendumProducts"
              [placeholder]="'Enter Addendum Products'"
              [requiredLabel]="false"
            ></currency-input-field>
            @if (incentiveForm.get('addendumProducts')?.hasError('min') && incentiveFormRef?.submitted) {
              <div class="text-danger small mt-1">Addendum Products must be a positive value</div>
            }
          </div>
        </div>
        <div class="d-flex justify-content-end gap-3 align-items-center mt-3">
          <h5 class="mb-0 fw-semibold text-dark">Total</h5>
          <h5 class="mb-0 fw-bold text-primary">{{ formatCurrency(totalAmount()) }}</h5>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-h45" (click)="modal.dismiss('Cancel click')">Cancel</button>
        @if (canWriteDeals()) {
          <button type="submit" class="btn btn-primary btn-h45" appBtnLoader="deal-save-incentive">
            {{ isEditMode() ? 'Update' : 'Add' }} Incentive
          </button>
        }
      </div>
    </div>
  </form>
</ng-template>
